import fetch from 'isomorphic-fetch';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

export default function fetchPromotion(pkey) {
  return () => (
    fetch(`/web-api/v1/promotion/key/${pkey}`,
      {
        credentials: 'same-origin',
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => json)
  );
}



// WEBPACK FOOTER //
// ./src/actions/PromotionActions.js